<template>
    <Breadcrumbs main="Buttons" title="Flat Buttons" />
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <flatsButtons />
                <flatsButtons2 />
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const flatsButtons = defineAsyncComponent(() => import("@/components/theme/buttons/flat/flatsButtons.vue"))
const flatsButtons2 = defineAsyncComponent(() => import("@/components/theme/buttons/flat/flatsButtons2.vue"))

</script>